import type {
  FailedRequestErrorLike,
  FailedRequestRecord,
} from '../types/failed-request-log.types'

type StoredFailedRequest = {
  recordedAt: number
  record: FailedRequestRecord
}

const MAX_RECORDS = 5
const DEFAULT_RECENCY_WINDOW_MS = 30_000

const failedRequests: StoredFailedRequest[] = []

function buildFullUrl(baseURL?: string, url?: string): string | undefined {
  if (!url) {
    return baseURL || undefined
  }
  if (!baseURL || /^https?:\/\//.test(url)) {
    return url
  }
  return `${baseURL.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`
}

function parseBody(data: unknown): unknown {
  if (typeof data !== 'string') {
    return data
  }
  try {
    return JSON.parse(data)
  } catch {
    return data
  }
}

export function recordFailedRequest(error: FailedRequestErrorLike): void {
  const config = error.config
  const requestId = config?.headers?.['X-Request-ID']
  const record: FailedRequestRecord = {
    occurredAt: new Date().toISOString(),
    request: {
      method: config?.method?.toUpperCase(),
      url: buildFullUrl(config?.baseURL, config?.url),
      requestId: typeof requestId === 'string' ? requestId : undefined,
      params: config?.params,
      body: parseBody(config?.data),
    },
    ...(error.response
      ? {
          response: {
            status: error.response.status,
            body: error.response.data,
          },
        }
      : { errorMessage: error.message }),
  }
  failedRequests.push({ recordedAt: Date.now(), record })
  if (failedRequests.length > MAX_RECORDS) {
    failedRequests.shift()
  }
}

export function getRecentFailedRequests(
  withinMs: number = DEFAULT_RECENCY_WINDOW_MS,
): FailedRequestRecord[] {
  const cutoff = Date.now() - withinMs
  return failedRequests
    .filter(({ recordedAt }) => recordedAt >= cutoff)
    .map(({ record }) => record)
}

export function formatFailedRequestsForClipboard(
  records: FailedRequestRecord[],
): string {
  return JSON.stringify(records, null, 2)
}
